module.exports = __webpack_public_path__ + "static/media/7-4.71b5877b.mp3";